import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "OverallReduction"
});
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2 = /* @__PURE__ */ _createStaticVNode('<path fill-rule="evenodd" clip-rule="evenodd" d="M6.75 7.5C6.75 7.08579 7.08579 6.75 7.5 6.75H16.5C16.9142 6.75 17.25 7.08579 17.25 7.5V16.5C17.25 16.9142 16.9142 17.25 16.5 17.25H7.5C7.08579 17.25 6.75 16.9142 6.75 16.5V7.5ZM8.25 8.25V15.75H15.75V8.25H8.25Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M1.75 17.75H5.5C5.91421 17.75 6.25 18.0858 6.25 18.5V22.25H4.75V19.25H1.75V17.75Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M17.75 18.5C17.75 18.0858 18.0858 17.75 18.5 17.75H22.25V19.25H19.25V22.25H17.75V18.5Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M6.25 1.75V5.5C6.25 5.91421 5.91421 6.25 5.5 6.25H1.75V4.75H4.75V1.75H6.25Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19.25 1.75V4.75H22.25V6.25H18.5C18.0858 6.25 17.75 5.91421 17.75 5.5V1.75H19.25Z"></path>', 5);
const _hoisted_7 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/OverallReduction.vue"]]);
